import React, { useEffect, useState } from 'react';
import PageLayout from '../../../../../../layout/dashboard/tableLayout';
import DashboardLayout from '../../../../../../layout/dashboard/dashboardLayout';
import CacDetails from './UploadPages/CacDetails';
// import CacDocuments from './UploadPages/CacDocuments';
import './UploadFile.css';
import { icons } from '../../../../../../assets/icons';
import CacDoc from './UploadPages/CacDoc';

interface SidebarTabsProps {
	activeTab: string;
	setActiveTab: (tab: string) => void;
}

const UploadFile = ({ activeTab, setActiveTab }: SidebarTabsProps) => {
	const tabs = [
		{ id: 'details', label: 'CAC Details' },
		{ id: 'documents', label: 'CAC Documents' },
	];
	const [rcNumber, setRcNumber] = useState('');
	const [searchTerm, setSearchTerm] = useState('');
	const [businessEmail, setbusinessEmail] = useState('');
	const [id, setbusinessId] = useState<any>('');
	// //('busid', id);

	useEffect(() => {
		if (activeTab !== 'details' && activeTab !== 'documents') {
			localStorage.removeItem('rc-name');
			localStorage.removeItem('selected-business');
		}
	}, [activeTab]);

	return (
		<DashboardLayout back>
			<PageLayout pageTitle="" pageSubtitle="" topRightContent={<></>}>
				<div className="containers">
					{/* Sidebar */}
					<div className="sidebar">
						{tabs.map((tab, idx) => (
							<div
								key={tab.id}
								className={`sidebar-tab ${
									activeTab === tab.id ? 'active' : ''
								}`}
								onClick={() => setActiveTab(tab.id)}
							>
								<div
									style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
								>
									<figure>
										{React.cloneElement(icons?.chevronright, {
											style: {
												stroke:
													activeTab === tab.id
														? 'var(--primary-base-color) !important'
														: 'inherit',
											},
										})}
									</figure>
									{tab.label}
								</div>
							</div>
						))}
					</div>

					{/* Main Section */}
					<div className="main-content">
						{activeTab === 'details' && (
							<CacDetails
								setActiveTab={setActiveTab}
								rcNumber={rcNumber}
								setRcNumber={setRcNumber}
								searchTerm={searchTerm}
								setSearchTerm={(param) => {
									setSearchTerm(param);
								}}
								setbusinessEmail={setbusinessEmail}
								setbusinessId={setbusinessId}
							/>
						)}
						{activeTab === 'documents' && (
							<CacDoc
								rcNumber={rcNumber}
								businessEmail={businessEmail}
								id={id}
							/>
						)}
					</div>
				</div>
			</PageLayout>
		</DashboardLayout>
	);
};

export default UploadFile;
